import React, { createContext } from 'react';

type SidebarContextType = {
    hide: boolean;
    setHide: React.Dispatch<React.SetStateAction<boolean>>;
};

const SidebarContext = createContext<SidebarContextType>(undefined);

interface Props {
    children: JSX.Element | JSX.Element[];
}

const SidebarProvider = ({ children }: Props): JSX.Element => {
    const [hide, setHide] = React.useState<boolean>(false);
    return <SidebarContext.Provider value={{ hide, setHide }}>{children}</SidebarContext.Provider>;
};

export { SidebarProvider, SidebarContext };
